import classNames from 'classnames';
import { FC, memo } from 'react';

import { AvatarPlaceholder, AvatarPlaceholderType } from '@gem/components';
import { Skeleton } from '@gem/ui-kit';

import styles from './InfoCardPlaceholder.styles.m.css';

interface InfoCardPlaceholderProps {
  className?: string;
  avatarType?: AvatarPlaceholderType;
  isFirstAnimated: boolean;
  isSecondAnimated: boolean;
}

const SKELETON_ANIMATION_CONFIG = {
  duration: 1000,
  endPosition: '200px',
};

export const InfoCardPlaceholder: FC<InfoCardPlaceholderProps> = memo((props) => {
  const {
    className,
    avatarType = AvatarPlaceholderType.Round_10,
    isFirstAnimated,
    isSecondAnimated,
  } = props;

  return (
    <div className={classNames(styles.container, className)}>
      <AvatarPlaceholder
        type={avatarType}
        isAnimated={isFirstAnimated}
      />
      <div className={styles.content}>
        <Skeleton
          isAnimated={isSecondAnimated}
          borderRadius="6px"
          width="140px"
          height="20px"
          className={styles.firstLine}
          animationConfig={SKELETON_ANIMATION_CONFIG}
        />
        <Skeleton
          isAnimated={isSecondAnimated}
          borderRadius="6px"
          width="110px"
          height="16px"
          animationConfig={SKELETON_ANIMATION_CONFIG}
        />
      </div>
    </div>
  );
});
